<div class="c-keyvalue">
  <div class="c-keyvalue__key">{{key}}</div>
  @if (!loading) {
    <div>
      @if (value !== 'undefined' && value !== null && value !== '') {
        <div class="c-keyvalue__value" >{{value}} {{unit}}</div>
      }
      @if (value === 'undefined' || value === null || value === '') {
        <div class="c-keyvalue__value" >{{ alt }}</div>
      }
    </div>
  }
  @if (loading) {
    <div class="c-keyvalue__value"><span><i class="fa fa-spinner fa-pulse fa-fw"></i></span></div>
  }
</div>
